/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./user-password-check-token-action-body').UserPasswordCheckTokenActionBody} UserPasswordCheckTokenActionBody
 */

/**
 * @typedef {import('./user-password-check-token-action-response').UserPasswordCheckTokenActionResponse} UserPasswordCheckTokenActionResponse
 */

/**
 * The path of the UserPasswordCheckTokenAction action.
 */
export const userPasswordCheckTokenActionPath = new SweetPath('/api/user/password/check-token', { path: '{param}' });

/**
 * Creates a contextualized UserPasswordCheckTokenAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createUserPasswordCheckTokenAction(axios) {
  /**
   * The userPasswordCheckTokenAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: UserPasswordCheckTokenActionBody } }
   *
   * @returns {Promise<UserPasswordCheckTokenActionResponse>}
   */
  function userPasswordCheckTokenAction({ headers = {}, parameters = {}, body } = {}) {
    const path = userPasswordCheckTokenActionPath.insert(parameters);

    return axios.post(path, body, { headers });
  }

  return userPasswordCheckTokenAction;
}
